export default "__VITE_ASSET__Cll5IsOE__"